<template>
  <v-form v-model="valid">
    <v-container>
      <v-row>
        <v-col
          cols="12"
          md="12"
        >
          <h1>User : {{ user.firstName }} {{ user.lastName }}</h1>

          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td>Email</td>
                  <td>
                    <FormulateInput
                      type="text"
                      name="Email"
                      v-model="user.email"
                      readonly
                    />
                  </td>
                </tr>
                <tr>
                  <td>Firstname</td>
                  <td>
                    <FormulateInput
                      type="text"
                      name="Firstame"
                      v-model="user.firstName"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Lastname</td>
                  <td>
                    <FormulateInput
                      type="text"
                      name="Lastname"
                      v-model="user.lastName"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Phone</td>
                  <td>
                    <FormulateInput
                      type="text"
                      name="Phone"
                      v-model="user.phone"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Address</td>
                  <td>
                    <FormulateInput
                      type="text"
                      name="Address"
                      v-model="user.address"
                    />
                  </td>
                </tr>

                <tr>
                  <td>Zip</td>
                  <td>
                    <FormulateInput
                      type="text"
                      name="Zip"
                      v-model="user.zip"
                    />
                  </td>
                </tr>
                <tr>
                  <td>City</td>
                  <td>
                    <FormulateInput
                      type="text"
                      name="City"
                      v-model="user.city"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Family member</td>
                  <td>
                    <FormulateInput
                      type="checkbox"
                      name="Family member"
                      v-model="user.familyMember"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Ambassador</td>
                  <td>
                    <FormulateInput
                      type="checkbox"
                      name="Ambassador"
                      v-model="user.ambassador"
                    />
                  </td>
                </tr>

                <tr>
                  <td>Role</td>
                  <td lg="2">
                    <v-select
                      :items="roles"
                      v-model="user.roles"
                      chips
                    ></v-select>
                  </td>
                </tr>
                <tr v-show="user.roles == 'CenterAdmin' && centers != false">
                  <td>Editor in centers</td>
                  <td>
                    <v-select
                      v-model="user.editorForCenters"
                      item-text="name"
                      item-value="rowKey"
                      :items="centers"
                      multiple
                      chips
                    ></v-select>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-btn
            :disabled="!valid"
            color="success"
            class="mr-4"
            @click="save"
          >Save User</v-btn>

        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          md="12"
        >
          <h1>Calendar bookings ({{bookingsResult.sessions}}), guests ({{bookingsResult.sessionsGuests}}), total ({{bookingsResult.sessionsTotal}}) </h1>

          <v-simple-table
            fixed-header
            height="400px"
            dense
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Dato</th>
                  <th class="text-left">Gæster</th>
                  <th class="text-left">Center</th>

                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="booking in bookingsResult.bookings"
                  :key="booking.rowKey"
                >
                  <td>{{ booking.start | fullDateTime }}</td>
                  <td>{{ booking.guests }}</td>
                  <td>{{ booking.center }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

        </v-col>
      </v-row>

      <v-snackbar
        v-model="showSnackbar"
        :multi-line="false"
        :timeout="5000"
        dark
        color="#EE765E"
        class="title"
      >
        {{ snackbarText }}
        <v-btn
          color="white"
          text
          @click="showSnackbar = false"
        >Luk</v-btn>
      </v-snackbar>
    </v-container>
  </v-form>
</template>

<script>
// import {    EventBus} from './../../event-bus.js';

//import store from "./../../store";
import core from "./../../mixins/core";

import Vue from "vue";
import VueFormulate from "@braid/vue-formulate";
import store from "../../store";
Vue.use(VueFormulate);

export default {
  data: function () {
    return {
      roles: ["User", "CenterAdmin", "Admin"],
      showSnackbar: false,
      snackbarText: "",
      valid: true,
      bookingsResult: false,
      sessions: 0,
      centers: false,
      user: {
        email: "",
        rowKey: "",
        firstName: "",
        lastName: "",
      },
      nameRules: [
        //   v => !!v || 'Name is required',
        //   v => v.length <= 10 || 'Name must be less than 10 characters',
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
    };
  },
  mixins: [core],
  mounted() {
    this.user.rowKey = this.$route.params.id;
    this.fetchUser2(this.user).then((user) => {
      this.user = user;
      this.fetchUserBookings(this.user).then((bookingsResult) => {
        this.bookingsResult = bookingsResult;
      });
    });

    this.centers = store.getters.centers;
  },
  methods: {
    save() {
      this.addUpdateUser(this.user).then((user) => {
        //store.commit("setUser", user);
        this.user = user;
        this.showSnackbar = true;
        this.snackbarText =
          "User " + user.firstName + " " + user.lastName + " saved";
      });
    },
  },
  name: "User",
};
</script>
